import { Enum } from "@/utilities/enums/Enum.ts";

export const E_ChatBot = Object.freeze({
  MAIN: "/bot",
});

export type E_ChatBot = Enum<typeof E_ChatBot>;
